import { IBrief } from "../../briefs";
import { IClassroom } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IUserResource } from "../../users";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { mapRelationalFilterToIRI, mapRelationalValueAsIRI } from "../../utils/filters";
import { IGroupSpace } from "../types";

export type IGroupSpaceCreateMutationParameters = {
    uuid: string;
    classroom: IClassroom;
    brief: IBrief;
    learners: IUserResource[];
};

export type IGroupSpaceCreateMutationResult = IGroupSpace;

export const groupSpaceCreateMutation: IApiMutationFunction<IGroupSpaceCreateMutationParameters> = ({
    classroom,
    brief,
    learners,
    ...data
}) => {
    return {
        method: "POST",
        url: `/group_spaces`,
        data: {
            ...data,
            classroom: mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom),
            brief: mapRelationalValueAsIRI(EntityTypes.BRIEF, brief),
            learners: mapRelationalFilterToIRI(EntityTypes.USER, learners),
            ...data,
        },
    };
};

export const useGroupSpaceCreateMutation = createApiMutationHook<
    IGroupSpaceCreateMutationParameters,
    IGroupSpaceCreateMutationResult
>(groupSpaceCreateMutation);
